import supabase from '../supabase/supabase';

/**
 * Performs lightweight head queries on all main tables to ensure 
 * Supabase detects active traffic and keeps the database instance warm.
 * This uses head: true and limit(1) to minimize data transfer and processing.
 */
export const pokeDatabase = async () => {
  try {
    // We use head: true to only get headers/count, not the actual data
    // This is the lightest possible way to "touch" a table
    await Promise.allSettled([
      supabase.from('profiles').select('id', { count: 'exact', head: true }).limit(1),
      supabase.from('user_usage').select('user_id', { count: 'exact', head: true }).limit(1),
      supabase.from('custom_foods').select('id', { count: 'exact', head: true }).limit(1),
      supabase.from('favorite_meals').select('id', { count: 'exact', head: true }).limit(1)
    ]);
    
    if (import.meta.env.DEV) {
      console.log('Database keep-alive ping successful across all primary tables.');
    }
  } catch (error) {
    // Silently handle errors as this is a background optimization task
    // and should never disrupt the user experience.
    console.warn('Database warmup encountered a minor issue, but app execution continues.');
  }
};